import {createContext} from 'react';

export type TurnstileContextProps = {
  resetToken?: () => void;
  token?: string;
};

export const TurnstileContext = createContext<TurnstileContextProps>({});
